import './App.css';
import Dice from './components/Dice';
import React, { useEffect } from 'react';
import { nanoid } from 'nanoid'
import Confetti from 'react-confetti';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRepeat } from '@fortawesome/free-solid-svg-icons'


/*
Features to implement:
[ ] Flashing dices (or any other indicator of roll)
[ ] Reseting highscore
[ ] New highscore notification
*/

function App() {

  const [diceArray, setDiceArray] = React.useState(allNewDice())
  const [tenzies, setTenzies] = React.useState(false)
  const [counter, setCounter] = React.useState({roll: 1, holded: 0, highScore: 1000})

  /* Checking if the game is won: */
  useEffect(() => {
    diceArray.every(dice => dice.isHeld && dice.value === diceArray[0].value) ? setTenzies(true) : setTenzies(false)
  }, [diceArray])

  /* Updating highscore only when it changes */

  useEffect(() => {
    if(localStorage.getItem("highscore") !== null) {
      console.log("checking storage...")
      counter.highScore < localStorage.getItem("highscore") ? 
      localStorage.setItem("highscore", counter.highScore) 
      : setCounter(prevCount => ({...prevCount, highScore: localStorage.getItem("highscore")}))
    }
  }, [counter.highScore])
  
  /* Reset all dices in state  */

  function allNewDice() {
    const arr = Array.from({ length: 10 }, () => Math.floor(Math.random() * 6) + 1)
    return arr.map(value => ({
      value: value,
      isHeld: false,
      id: nanoid()
    }))
  }


  /* Render Dice components */

  function renderDices() {
    return diceArray.map(dice => <Dice value={dice.value} key={dice.id} isHeld={dice.isHeld} clickHandler={() => holdDice(dice.id)} />
    )
  }

  /* Roll unhold dices */

  function roll() {
    if(tenzies) {
      // If game is won:
      // Fill Dice Array with new dices:
      setDiceArray(allNewDice) 
      // Prepare new Counter object to save in the state:
      const newCounter = counter.roll < counter.highScore ? {roll: 1, holded: 0, highScore: counter.roll} : {...counter, roll: 1, holded: 0}
      // Check for Highscore, if true - set new highscore in localStorage:
      newCounter.highScore < counter.highScore && localStorage.setItem("highscore", newCounter.highScore)
      // Set new counter as current counter:
      setCounter(newCounter)
    } else {
      // Game is not won
      // Roll new values for unhold dices
      setDiceArray(prevArray => prevArray.map(dice => dice.isHeld ? dice : { ...dice, id: nanoid(), value: Math.floor(Math.random() * 6) + 1 }))
      // increase current roll value
      setCounter(prevCount => ({...prevCount, roll: prevCount.roll + 1}))
    }
  }

  /* Hold dice */

  function holdDice(id) {
    setDiceArray(prevArray => prevArray.map(dice => dice.id === id ? { ...dice, isHeld: !dice.isHeld } : dice))
    // Change the amount of holded dices:
    setCounter(prevCount => ({...prevCount, holded: diceArray.filter(dice => dice.isHeld === true).length + 1}))
  }

  function resetHighscore() {
    localStorage.removeItem("highscore")
    setCounter(prevCount => ({...prevCount, highScore: 1000}))
  }

  function showHighscore() {
    if (counter.highScore < 1000) {
      return <p> Highscore: {counter.highScore} <button className="reset" onClick={resetHighscore}><FontAwesomeIcon icon={faRepeat} size="sm"/></button></p>
    }
  }
  

  return (
    <main>
      {/* If game is won - render Confetti! */}
      {tenzies && <Confetti />}
      <h1>Tenzies</h1>
      <p className="description">Roll until all dice are the same. Click each die to freeze it at its current value between rolls.</p>
      <div className="dice-container">
        {renderDices()}
      </div>
      <button className="roll" onClick={roll}>
        {/* If game is won - display New Game instead of Roll */}
        {tenzies ? "New Game" : "Roll"}
      </button>
      <div className="counter">
      <p>{counter.holded} / 10</p>
      <p>{tenzies ? "Winning" : "Current"} Roll: {counter.roll} </p>
      {/* If highScore is different than default value of 1000 - display it: */}
      {showHighscore()}
      </div>

    </main>
  );
}

export default App;
